import { render, staticRenderFns } from "./CamaraEnVivoPantalla.vue?vue&type=template&id=2fd30848&scoped=true&"
import script from "./CamaraEnVivoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoPantalla.vue?vue&type=style&index=0&id=2fd30848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd30848",
  null
  
)

export default component.exports